<template>
    <div style="display: flex; padding: 20px;">
        <div class="tree-wrapper">
            <p><b>EFO Ontology Tree</b></p>
            <div class="tree-box">
                <el-tree
                    :expand-on-click-node="false"
                    :data="treeData"
                    node-key="id"
                    :props="{ label: 'name' }"
                    :default-expanded-keys="expandNode"
                    @node-click="handleClickNode"
                />
            </div>
        </div>
        <div style="flex-grow: 1">
            <div class="header-tool">
                <input @input="handleSearchInput" class="form-control search-input" />
                <el-button size="mini" @click.native="exportTable"><i class="glyphicon glyphicon-download-alt"></i></el-button>
            </div>
            <t-table
                id="mainTable"
                :data="tableData.data"
                :pageSize="queryTableParams.pageSize"
                :curPage="queryTableParams.pageNum"
                :total="tableData.total"
                @current-change="handleTableCurrentChange"
                @sort-change="handleSortable"
                @size-change="handleTablePageSize"
            >
                <t-table-column label="DAID" property="daid" width="14%"  sortable>
                    <template slot-scope="{ row }">
                        <router-link :to="`/trait/${row.traitId}`">{{ row.daid }}</router-link>
                    </template>
                </t-table-column>
                <t-table-column label="Reported Trait" property="reportedTrait" width="30%"  sortable>
                    <template slot-scope="{ row }">
                        <router-link :to="`/trait/${row.traitId}`">{{ row.reportedTrait }}</router-link>
                    </template>
                </t-table-column>
                <t-table-column label="Trait Label" property="efoOntologyTrait" width="25%" sortable>
                    <template slot-scope="{ row }">
                        <router-link :to="`/trait/${row.traitId}`">{{ row.efoOntologyTrait }}</router-link>
                    </template>
                </t-table-column>
                <t-table-column label="Trait Ontology ID" property="efoCode" width="12%"  sortable>
                    <template slot-scope="{ row }">
                        <router-link :to="`/trait/${row.traitId}`">{{ row.efoCode }} <i class="glyphicon glyphicon-share" style="margin-left: 5px"></i></router-link>
                    </template>
                </t-table-column>
                <t-table-column label="Sample Size" property="sampleSize" width="8%" sortable>
                    <template slot-scope="{ row }">
                        <span>{{row.sampleSize}}</span>
                    </template>
                </t-table-column>
                <t-table-column label="Num Cases" property="ncase" width="5%" sortable>
                    <span slot-scope="{ row }">{{ row.ncase }}</span>
                </t-table-column>
                <t-table-column label="Num Controls" property="ncontrol" width="5%" sortable>
                    <span slot-scope="{ row }">{{ row.ncontrol }}</span>
                </t-table-column>
                <t-table-column label="Population" property="population" width="8%" sortable>
                    <template slot-scope="{ row }">
                        <span>{{row.population}}</span>
                    </template>
                </t-table-column>
                <t-table-column label="PMID" property="pmid" width="8%" sortable>
                    <span slot-scope="{ row }">{{ row.pmid }}</span>
                </t-table-column>
                <t-table-column label="#Associations" property="associationCount" width="10%" sortable>
                    <span slot-scope="{ row }">Gene: {{ row.geneCount }}</span>
                </t-table-column>
                <t-table-column label="Download" property="link" width="40" >
                    <a slot-scope="{ row }" :href="`/download/jlucaochen-1315664645/${row.daid}.txt.gz`" target="_blank"><i class="glyphicon glyphicon-download-alt"></i></a>
                </t-table-column>
            </t-table>
        </div>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";

export default {
    name: "traits",
    mixins: [table_mix],
    data() {
        return {
            treeData: [],
            expandNode: [],
        };
    },

    computed: {
        getTableDataAjaxUrl() {
            return "trait/page";
        },
    },

    created() {
        this.refreshTable();
        this.handleGetTreeData();
    },

    methods: {
        showPublications(row) {
            row.showPublications = !row.showPublications;
        },

        getTableDataAfter(list) {
            list.forEach(v => {
                v.showPublications = false;
            });
        },

        handleClickNode(data) {
            this.queryTableParams.categoryId = data.id || "";
            this.resetRefreshTable();
        },

        exportTable() {
            window.open(`/api/trait/export?keyword=${this.queryTableParams.keyword}&categoryId=${this.queryTableParams.categoryId ? this.queryTableParams.categoryId : ''}`, '_blank')
        },

        download(row) {
            const url = `http://43.154.5.46:8888/download/jlucaochen-1315664645/${row.daid}.txt.gz`
            const a = document.createElement('a')
            a.href = url
            a.download = `${row.daid}.txt.gz`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async handleGetTreeData() {
            let res = await this.$ajax.get("category/tree");
            (res.data || []).forEach(v => {
                this.expandNode.push(v.id);
            });
            this.expandNode.push("all");
            this.treeData = [{ name: "All", children: res.data, id: "" }];
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/common/style/traDetail";

.search-input {
    display: inline-block;
    width: 200px;
}

.tree-wrapper {
    margin: 20px 0px 0 0;
}

.tree-box {
    width: 250px;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin-right: 10px;
    margin-top: 13px;
    max-height: calc(100vh - 260px);
    overflow: auto;

    /deep/ .el-tree-node {
        min-width: fit-content;
    }
}
</style>
